/*
 * Title:  Rewards/EarnTabContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Earn Content page content listing, click on list to expand.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import { Fragment, useState, useRef } from "react";
import { connect } from "react-redux";
import close from "@assets/close.png";
import Loader from "@components/Loader";
import Buttonlink from "@components/Button";
import { Dialog, Transition } from "@headlessui/react";
import { motion } from "framer-motion";
import {calculateRedumptionTiime} from "@helpers/common";

import EarnContentItem from "@components/Rewards/EarnContentItem";
import {
	numberFormat,
	currencyFormat,
} from "@helpers/common";
import Successfull from "@components/Successful";
import SurveyPopUp from "@components/SurveyPopUp";
import Api from "@services/api";
import QrcodeScanner from "@components/QrcodeScanner";

const animations = {
	initial: { opacity: 0, x: -100 },
	animate: { opacity: 1, x: 0 },
	exit: { opacity: 0, x: 100 },
};

const sort = (array: any, field:any) => {
	array.sort(function(a, b){
		if(a?.[field].toLowerCase() < b?.[field].toLowerCase() ) { return -1; }
		if(a?.[field].toLowerCase()  > b?.[field].toLowerCase() ) { return 1; }
		return 0;
	});
	return array;
  };

type Props = {
	authInstagram(data: any);
	onLogoutSuccess?: () => void;
	onLoginStart?: () => void;
	fetchRewards(creator_id: String);
};

const EarnContent: React.FC<Props | any> = (props) => {
	const [open, setOpen] = useState(false);
	const popupRef = useRef(null);
	const [value, setValue] = useState(1);
	const [popup, setPopup] = useState(false);
	const [item, setItem] = useState({});
	const [loader, setLoader] = useState({});
	const surveyRef = useRef(null);


	const _onChangeValue = (e) => {
		setValue(e.target.value);
	};

	const fetchEarnRewards = () => {
		props.fetchEarnRewards(props?.data?.id);
	};

	const fetchScore = () => {
		props.fetchScore(props.programData?.program?.id, {
			fanId: props.user?.user?.data?.id,
			programId: props.programData?.program?.id,
		});
	};

	const startSurvey = (data) => {
		surveyRef?.current?.open(data);
	};
	const subscribe = async () => {
		const json = await Api.subscribeActionItemEvent(props?.data?.id);
		fetchEarnRewards();
		fetchScore();
	};

	const fetchRewardAfterFollow = () => {
		const timer = setTimeout(() => {
			fetchEarnRewards();
			fetchScore();
		}, 60000);
		return () => clearTimeout(timer);
	};

	const followRecheck = (data) => {
		const timer = setTimeout(() => {
			Api.followCheck(data.creatorId, data.type, data.touchpointId);
			fetchRewardAfterFollow();
		}, 15000);
		return () => clearTimeout(timer);
	};

	const updateTouchpoints = (data) => {
		data["creatorId"] = props?.data?.id;
		props.updateTouchpoints(data);
		followRecheck(data);
	};

	const openCamera = () => {
		popupRef?.current?.open();
	}

	const closeCamera = () => {
		popupRef?.current?.close();
	}


	let actions = [];
	let touchpoints = sort(props.touchpoints || [], 'name');

	touchpoints.filter(i=>i.active && i.actions.filter(i=>i.config?.active).length>0).map((item) => {
		const action = (item.actions.filter(i=>i.action=="connect")?.[0] || {});
			let redeemed = [];
			let notRedeemed = [];
			item.actions.map((i)=>{
			if(i?.config?.active){
				let datum = i;
				datum = {
					...datum,
					touchpoint:{
						name:item.name,
						id:item.id,
						url:item?.url,
					}
				}
				if(action?.config?.limit!=action?.shares?.fanEngagement){
					datum = {
						...datum,
						socialAction:action
					}
				}
				const config = calculateRedumptionTiime(datum?.config, datum?.shares?.lastEngagement, datum?.shares?.fanEngagement, datum?.totalEngagements, -1);
				if(config?.isCardHide){
				} else if(config?.isDisabled){
					redeemed.push(datum);
				} else {
					
					notRedeemed.push(datum);
				}

				
			}
		});
		actions.push(...sort(notRedeemed, "title"), ...sort(redeemed, 'title'));
		
	});
	

	return (
		<div
			className="overflow-y-auto overflow-x-hidden lg:mt-[20px] px-1 lg:h-[calc(100vh-265px)] lg:pb-[100px] pb-[30px]"
			id="scrollbar"
		>

			<motion.div
				variants={animations}
				initial="initial"
				animate="animate"
				exit="exit"
				transition={{ duration: 0.5 }}
			>
				{/* Loader  */}

				{props.isFetching && <Loader height={30} width={30} />}
				
				<div>
					{actions?.map((reward, index2) => {
					return (
						<EarnContentItem
						item={reward}
						redemptionInfo={reward.shares}
						touchpoint={item}
						redeemed={reward?.shares?.pointsEarned > 0}
						key={index2}
						user={props.user}
						data={props.data}
						fetchEarnRewards={fetchEarnRewards}
						fetchScore={fetchScore}
						startSurvey={startSurvey}
						subscribe={subscribe}
						updateTouchpoints={updateTouchpoints}
						username={props.data?.username}
						loader={loader}
						openCamera={openCamera}
						closeCamera={closeCamera}
						/>
					);
					})}
				</div>

				<QrcodeScanner ref={popupRef} />
	
				{/* donations popup from bottom start  */}
				<Transition.Root show={open} as={Fragment}>
					<Dialog as="div" className="relative z-50" onClose={setOpen}>
						<Transition.Child
							as={Fragment}
							enter="ease-in-out duration-500"
							enterFrom="opacity-0"
							enterTo="opacity-100 "
							leave="ease-in-out duration-500"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<div className="fixed inset-0 bg-black bg-opacity-80 transition-opacity" />
						</Transition.Child>

						<div className="fixed inset-0 overflow-hidden">
							<div className="absolute inset-0 overflow-hidden">
								<div className="fixed inset-x-0 bottom-0 flex max-w-full pointer-events-none">
									<Transition.Child
										as={Fragment}
										enter="transform transition ease-in-out duration-500 sm:duration-700"
										enterFrom="translate-y-full"
										enterTo="translate-y-0"
										leave="transform transition ease-in-out duration-500 sm:duration-700"
										leaveFrom="translate-y-0"
										leaveTo="translate-y-full"
									>
										<Dialog.Panel className="relative w-screen h-full overflow-hidden pointer-events-auto">
											<div className="bg-[#1D1D1D] py-6 shadow-xl px-4 sm:px-6 rounded-t-3xl">
												<div className="bg-[#fff]/10 lg:w-12 w-9 mx-auto h-1 rounded-full" />
												<div className="flex justify-end">
													<button
														type="button"
														className="text-white rounded-md outline-none hover:text-white hover:opacity-70"
														onClick={() => setOpen(false)}
													>
														<span className="sr-only">Close panel</span>
														<img
															src={close}
															alt="Close"
															className="object-contain w-4 h-4"
														/>
													</button>
												</div>
												<div className="mt-5 space-y-8">
													<div>
														<h4 className="font-medium text-white lg:text-[24px] text-[18px] text-center">
															Make a Donation
														</h4>
														<p className="mt-2 text-[#fff]/50 font-normal text-[16px] text-center uppercase tracking-wider">
															Earn 2.5 points for every $1 you donate.
														</p>
													</div>

													<div className="bg-[#fff]/10 rounded-xl py-5 space-y-8 w-32 mx-auto">
														<div className="text-center">
															<p className="text-[#fff]/50 font-normal text-[16px] uppercase tracking-wider">
																DONATION
															</p>
															<p className="primary font-semibold lg:text-[28px] text-[18px] uppercase tracking-wider">
																${value}
															</p>
														</div>
													</div>
													<div className="max-w-[320px] mx-auto">
														<input
															type="range"
															min="1"
															max="100"
															className="rangeSlider"
															value={value}
															onChange={_onChangeValue}
														/>
														<div className="flex items-center justify-center mt-2 gap-x-1">
															<p className="text-[#fff]/50 font-normal text-[16px] tracking-wider">
																Value:
															</p>
															<p className="text-[#fff]/80 font-normal text-[16px] uppercase tracking-wider">
																{currencyFormat(value)}
															</p>
														</div>
													</div>
													<div className="text-center">
														<p className="text-[#fff]/50 font-normal text-[16px] uppercase tracking-wider">
															POINTS EARNED
														</p>
														<p className="green font-medium lg:text-[24px] text-[18px] uppercase tracking-wider">
															{numberFormat(value * 2.5)}
														</p>
													</div>
													<Buttonlink
														text="donate now"
														className="flex items-center justify-center text-white font-medium gap-x-1 bg-tile rounded-full h-[42px] w-[189px] mx-auto"
													/>
												</div>
											</div>
										</Dialog.Panel>
									</Transition.Child>
								</div>
							</div>
						</div>
					</Dialog>
				</Transition.Root>
				{/* donations popup from bottom end */}
				{popup && <Successfull {...item} tile="tile" />}
			</motion.div>
			<SurveyPopUp ref={surveyRef} />
		</div>
	);
};

const mapStateToProps = ({ user, EarnReward, creator, RedeemReward }) => {
	return {
		instagram: user.instagram,
		discord: user.discord,
		touchpoints: EarnReward.data,
		isFetching: EarnReward.isFetching,
		shopify: user.shopify,
		user: user.user,
		programData: user.programData,
		data: creator.data,
		isRegistrationEnd: creator?.isRegistrationEnd,
		rewards: RedeemReward.data,
	};
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
	const { dispatch } = dispatchProps;
	const { actions } = require("@redux/UserRedux");
	const { rewardActions } = require("@redux/EarnRewardRedux");
	const { actions: scoreAction } = require("@redux/ScoreRedux");
	return {
		...stateProps,
		authInstagram: (data) => {
			dispatch(actions.authInstagram(data));
		},
		authDiscord: (data) => {
			dispatch(actions.authDiscord(data));
		},
		authShopify: (data) => {
			dispatch(actions.authShopify(data));
		},
		fetchEarnRewards: (creator_id) => {
			rewardActions.fetchEarnRewards(dispatch, creator_id);
		},
		fetchScore: (programId) => {
			scoreAction.fetchScores(dispatch, programId);
		},
		updateTouchpoints: (data) => {
			rewardActions.updateTouchpoints(dispatch, data);
		},
	};
};

export default connect(mapStateToProps, undefined, mergeProps)(EarnContent);
